"use strict";

var _AppFmoHomeViewerWhoAmIQuery, _Fragment, _span, _AuthProvider;
import { createClient, logout } from '@autoguru/auth';
import { AuthProvider, withRequiredAuthentication } from '@autoguru/auth/react-auth';
import { getToken } from '@autoguru/auth/relay';
import { NoResults, PageLoading } from '@autoguru/components';
import { Box, Button, Section, Stack, Text } from '@autoguru/overdrive';
import { EnvironmentProvider, createEnvironment } from '@autoguru/relay';
import { AsyncBoundary } from '@autoguru/suspense';
import { useCallback, useEffect } from 'react';
import { graphql, useLazyLoadQuery } from 'react-relay/hooks';
import { FLEET_GURU_CONTACTS, FLEET_PORTAL_URL, TENANT_NAME } from '@autoguru/global-configs';
import { formatPhoneNumber } from '@autoguru/phone-number-display';
import { useParams } from 'react-router-dom';
import { Landing } from '~/src/scenes/Landing';
import { Fragment as _Fragment2, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const authClient = createClient();
const relayModernEnvironment = createEnvironment({
  fetcherOptions: {
    getToken
  }
});
const AuthRequiredApp = withRequiredAuthentication(() => {
  const {
    viewer
  } = useLazyLoadQuery(_AppFmoHomeViewerWhoAmIQuery !== void 0 ? _AppFmoHomeViewerWhoAmIQuery : (_AppFmoHomeViewerWhoAmIQuery = require("../../../../packages/relay/__generated__/AppFmoHomeViewerWhoAmIQuery.graphql"), _AppFmoHomeViewerWhoAmIQuery.hash && _AppFmoHomeViewerWhoAmIQuery.hash !== "03b6c59935b09eefafc75fee5620dd88" && console.error("The definition of 'AppFmoHomeViewerWhoAmIQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _AppFmoHomeViewerWhoAmIQuery), {});
  useEffect(() => {
    if (viewer.canAccessPortal && viewer.fleetCompaniesAsManager.edges.length === 1) {
      window.location.assign(`${FLEET_PORTAL_URL}/${viewer.fleetCompaniesAsManager.edges[0].node.slug}/booking`);
    }
  }, [viewer]);

  // @ts-ignore
  const onRequestLogout = useCallback(() => logout(FLEET_PORTAL_URL), []);
  const {
    fmoSlug
  } = useParams();
  useEffect(() => {
    if (fmoSlug) {
      window.location.assign(`${FLEET_PORTAL_URL}/${fmoSlug}/booking`);
    }
  }, [fmoSlug]);
  return /*#__PURE__*/_jsx(Section, {
    width: "medium",
    children: viewer.canAccessPortal && viewer.fleetCompaniesAsManager.edges.length ? viewer.fleetCompaniesAsManager.edges.length === 1 ? _Fragment || (_Fragment = /*#__PURE__*/_jsx(_Fragment2, {})) : /*#__PURE__*/_jsx(Landing, {
      viewer: viewer
    }) : /*#__PURE__*/_jsx(NoResults, {
      boxed: false,
      title: viewer.canAccessPortal ? 'Account not active' : 'Unavailable product',
      children: /*#__PURE__*/_jsxs(Stack, {
        space: "3",
        children: [/*#__PURE__*/_jsxs(Stack, {
          space: "none",
          children: [/*#__PURE__*/_jsx(Text, {
            size: "3",
            as: "p",
            align: "center",
            children: viewer.canAccessPortal ? 'Sorry, we cannot find any fleet companies associated with this account.' : 'Sorry, this feature is not available with this account.'
          }), /*#__PURE__*/_jsxs(Text, {
            size: "3",
            as: "p",
            align: "center",
            children: ["If you need any help please call us on", _span || (_span = /*#__PURE__*/_jsx("span", {
              children: " "
            })), /*#__PURE__*/_jsx(Text, {
              size: "3",
              as: "span",
              children: formatPhoneNumber(FLEET_GURU_CONTACTS, TENANT_NAME)
            })]
          })]
        }), /*#__PURE__*/_jsx(Box, {
          width: "full",
          justifyContent: "center",
          display: "flex",
          children: /*#__PURE__*/_jsx(Button, {
            size: "small",
            onClick: onRequestLogout,
            children: "Log out"
          })
        })]
      })
    })
  });
}, true);
export const App = () => _AuthProvider || (_AuthProvider = /*#__PURE__*/_jsx(AuthProvider, {
  allow_socials: true,
  client: authClient,
  children: /*#__PURE__*/_jsx(AsyncBoundary, {
    fallback: PageLoading,
    children: /*#__PURE__*/_jsx(EnvironmentProvider, {
      environment: relayModernEnvironment,
      children: /*#__PURE__*/_jsx(AuthRequiredApp, {})
    })
  })
}));